import isEqual from 'lodash/isEqual';
import { queryArgs, siteId, siteIds, dates } from '@/utils';
import sumBy from 'lodash/sumBy';
export const perPage = 10;

const defaultQuery = {
	searchLead: null,
	dateStart: null,
	dateEnd: null,
	siteIds: siteIds ? siteIds.join(',') : siteId,
	campaigns: [],
	tags: [],
};
export default {
	leadsQueryArgs: (state, { dateRange }) => {
		return {
			page: state.page,
			perPage: perPage,
			searchLead: state.search,
			dateStart: dateRange.start ? dates.timestamp(dateRange.start) : null,
			dateEnd: dateRange.end ? dates.timestamp(dateRange.end) : null,
			siteIds: siteIds ? siteIds.join(',') : siteId,
			campaigns: state.filters.campaign ? [state.filters.campaign] : [],
			tags: state.filters.tag ? [state.filters.tag] : [],
		};
	},
	leadsQueryString: (state, { leadsQueryArgs }) => {
		return '?' + queryArgs.serialize(leadsQueryArgs);
	},
	isDefaultQuery: (state, getters) => {
		const data = getters.leadsQueryArgs;

		return !Object.keys(data).find((key) => {
			if (!(key in defaultQuery)) {
				return false;
			}

			if (data[key]) {
				return !isEqual(data[key], defaultQuery[key]);
			}

			return null !== defaultQuery[key];
		});
	},
	exportQueryString: (state, getters) => {
		let exportString = getters.leadsQueryString;
		Object.keys(state.export).forEach((key) => {
			exportString = queryArgs.add(`export[${key}]`, encodeURIComponent(state.export[key]), exportString);
		});

		return exportString;
	},

	campaignFilterOptions: (state) => {
		const options = state.filterOptions.campaigns.map((campaign) => {
			return {
				name: campaign.name,
				value: campaign.id,
			};
		});
		options.unshift({
			name: 'All Campaign Contacts',
			value: '',
		});
		return options;
	},
	tagFilterOptions: (state) => {
		const options = state.filterOptions.tags.map((tag) => {
			return {
				name: tag.name,
				value: tag.id,
			};
		});
		options.unshift({
			name: 'All Tags',
			value: '',
		});
		return options;
	},
	perPage: () => perPage,
	campaignFilter: (state) => state.filters.campaign,
	selectedCampaign: ({ filterOptions }, { campaignFilter }) => {
		return campaignFilter ? filterOptions.campaigns.find((c) => c.id === campaignFilter) : {};
	},
	tagFilter: (state) => state.filters.tag,
	selectedTag: ({ filterOptions }, { tagFilter }) => {
		return tagFilter ? filterOptions.tags.find((c) => c.id === tagFilter) : {};
	},

	statsPeriod: (state) => state.stats.period,
	statsDates: (state) => state.stats.dates,
	statsChange: (state) => state.stats.change,
	statsCurrent: (state) => state.stats.current,
	startEnd: (state) => {
		let { filter, start, end } = state.dateRange;

		switch (filter) {
			case '30-days':
				return dates.getDaysStartEnd(30);
			case '7-days':
				return dates.getDaysStartEnd(7);
			default:
				return { start, end };
		}
	},
	dateRange: ({ dateRange }, { startEnd }) => {
		return {
			...dateRange,
			...startEnd,
		};
	},
	allLeadsAllTime: (state) => sumBy(state.campaigns, 'leads_count_all_time'),
};
